<app-internal-banner [message]="'This page is for crew only. Clients cannot view this page.'">
</app-internal-banner>
<ng-container *ngIf="errorMessageWhileFetchingText">
  <div class="row mb-2">
    <div class="col-12">
      <c11n-banner [size]="'small'" [variant]="'error'">{{ errorMessageWhileFetchingText }}</c11n-banner>
    </div>
  </div>
</ng-container>

<!-- Text Wrapping Validation Errors Banner -->
<ng-container *ngIf="hasWrappingErrors && showErrors">
  <div class="row mb-2">
    <div class="col-12">
      <c11n-banner [size]="'small'" [variant]="'error'">
        <strong>Message text validation failed:</strong>
        <ul class="mb-0 mt-2">
          <li *ngFor="let error of textValidationErrors">{{ error }}</li>
        </ul>
      </c11n-banner>
    </div>
  </div>
</ng-container>

<!-- Warning Banner for Near Line Limit -->
<ng-container *ngIf="isNearLineLimit && !hasWrappingErrors">
  <div class="row mb-2">
    <div class="col-12">
      <c11n-banner [size]="'small'" [variant]="'warning'">
        <strong>Warning:</strong> You are near the maximum line limit. Only {{ maxLineCount - currentLineCount }} line(s) remaining.
      </c11n-banner>
    </div>
  </div>
</ng-container>

<div class="row mb-3">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center gap-2">
      <!--flex-shrink-0 prevents title from shrinking -->
      <div class="flex-shrink-0">
        <app-title [title]="'View message'"></app-title>
      </div>
      <!--flex-shrink-0 prevents menu from shrinking -->
      <div class="flex-shrink-0">
        <app-view-update-message-navigation-overflow-menu (menuItemClicked)="onMenuItemClick($event)">
        </app-view-update-message-navigation-overflow-menu>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="selectedMessageDetail">
  <form
    #messageContent
    autocomplete="off"
    [formGroup]="formGroup"
    (ngSubmit)="submitForm($event)">
    <!-- Message Details Section -->
    <div class="row mt-4">
      <div class="col-12">

        <div class="row">
          <!-- Left Column: Message Number, Type -->
          <div class="col-lg-6 col-md-6 col-sm-12 mb-3">

            <!-- Message Number -->
            <div class="mb-3">
              <div><strong>Message number</strong></div>
              <div>{{ selectedMessageDetail.messageId || '—' }}</div>
            </div>

            <!-- Message Type -->
            <div class="mb-3">
              <div><strong>Message type</strong></div>
              <div>{{ selectedMessageDetail.messageType || '—' }}</div>
            </div>

            <!-- permanent message -->
            <div class="mb-3">
              <c11n-checkbox [labelText]="'Permanent message'">
                <input
                  c11nCheckboxInput
                  id="is-permanent"
                  type="checkbox"
                  formControlName="isPermanent"
                  [attr.disabled]="isWaiting || isDeleteWaiting ? true : null"
                  [checked]="selectedMessageDetail.permanentMessageFlag"
                />
              </c11n-checkbox>
            </div>

          </div>

          <!-- Right Column: Verified By, Verify On, Line Quantity -->
          <div class="col-lg-6 col-md-6 col-sm-12 mb-3">

            <!-- Message Verified By -->
            <div class="mb-3">
              <div><strong>Message verified by</strong></div>
              <div>{{ selectedMessageDetail.verifyUserId || '—' }}</div>
            </div>

            <!-- Verify On -->
            <div class="mb-3">
              <div><strong>Verify on</strong></div>
              <div>{{ selectedMessageDetail.lastUpdatedTimestamp || '—' }}</div>
            </div>

            <!-- Line Quantity -->
            <div class="mb-3">
              <div><strong>Line quantity</strong></div>
              <div>{{ selectedMessageDetail.lineQuantity || '—' }}</div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <ng-container *ngIf="showFundFields">
      <div class="row">
        <div class="col-lg-7 col-md-12 col-sm-12 col-sm-12 c11n-space-stack-3x c11n-space--force mb-0">
          <c11n-select
            labelText="Fund id"
            [hintText]="''"
            [hasError]="false"
          >
            <select
              c11nSelectInput
              id="fund_id"
              [attr.disabled]="isWaiting || isDeleteWaiting? true : null"
              formControlName="fund_id"
            >
              <option *ngFor="let type of fundIds" [value]="type.fundPortId">{{ type | fundIdNameFormation }}</option>
            </select>
          </c11n-select>

        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force mb-0">
          <c11n-select
            labelText="Fund code"
            [hintText]="''"
            [hasError]="false"
          >
            <select
              c11nSelectInput
              id="fund_code"
              [attr.disabled]="isWaiting || isDeleteWaiting? true : null"
              formControlName="fund_code"
            >
              <option *ngFor="let type of fundCodeType" [value]="type">{{ type }}</option>
            </select>
          </c11n-select>
        </div>
      </div>
    </ng-container>
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12 col-sm-12 c11n-space-stack-3x c11n-space--force">
        <label c11n-label for="header">Header</label>
        <c11n-input>
          <input
            c11nInput
            id="header"
            placeholder="Header"
            [attr.readonly]="isWaiting || isDeleteWaiting? true : null"
            formControlName="header"
          />
        </c11n-input>
      </div>
    </div>

    <!-- Multiple Text Input Boxes -->
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12 col-sm-12 c11n-space-stack-3x c11n-space--force">
        <!-- Placeholder Message (when no message type selected) -->
        <div *ngIf="messageLines.length === 0">
          <c11n-banner [size]="'small'" [variant]="'basic'" [hasCloseControl]="false">
            Please wait while message data is loading...
          </c11n-banner>
        </div>

        <!-- Multiple Input Boxes Loop -->
        <div *ngIf="messageLines.length > 0">
          <div *ngFor="let line of messageLines; let i = index" class="mb-3">

            <!-- Label with character counter -->
            <div class="d-flex justify-content-between align-items-center">
          <label c11n-label [attr.for]="'line-' + i">
            Line {{ i + 1 }}<span *ngIf="i == 0" class="text-danger">*</span>
          </label>
          <small [ngClass]="getCharCountTextClass(i)">
            {{ getCharCountMessage(i) }}
          </small>
        </div>

        <!-- Input Field -->
         <c11n-input [hasError]="showErrors && line.invalid">
          <input
            #messageLineInput
            c11nInput
            [id]="'line-'+i"
            [formControl]="line"
            [placeholder]="'Enter text for line ' + (i+1)"
            [attr.readonly]="isWaiting || isDeleteWaiting ? true : null"
            (input)="onMessageLineInput(i, $event)"
            (keydown)="onMessageLineKeydown(i, $event)"
            (paste)="onMessageLinePaste(i, $event)"
          />
         </c11n-input>

         
         <!-- Warning: Character limit reached -->
            <div *ngIf="isLineLimitReached(i)" class="text-danger small mt-1">
              Character limit reached for this line
            </div>

         <!-- Validation Error Messages-->
        <c11n-hint-error
          *ngIf="showErrors && line.hasError('required')"
          errorText="Line 1 is required"
          [hintErrorId]="'line-' + i + '-required'"
          [hasError]="true"
        ></c11n-hint-error>

        <c11n-hint-error
          *ngIf="showErrors && line.hasError('maxlength')"
          [errorText]="'Line ' + (i + 1) + ' exceeds maximum character limit of ' + maxCharsPerLine"
          [hintErrorId]="'line-' + i + '-maxlength'"
          [hasError]="true"
        ></c11n-hint-error>

          </div>

        </div>

      </div>
    </div>

    <div class="row" *ngIf="messageLines.length > 0 && hasAnyLineContent()">
      <div class="col-lg-9 col-md-12 col-sm-12 col-sm-12 c11n-space-stack-3x c11n-space--force">
        <div class="wrapped-text-preview">
          <details open>
            <summary class="preview-header">
              <strong>
                <i class="bi bi-eye"></i> Live Preview
              </strong>
            </summary>
            <div class="preview-content mt-2">
              <div class="wrapped-lines-container">
                <div *ngFor="let line of messageLines; let i = index" class="wrapped-line">
                  <ng-container *ngIf="line.value !== null && line.value !== undefined">
                    <span class="line-number">{{ i + 1 }}.</span>
                    <span class="line-text" style="white-space: pre-wrap; word-break: break-word">{{ line.value }}</span>
                    <span class="char-count">
                      ({{ getNormalizedLength(line.value) }}/{{ maxCharsPerLine}})
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </details>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12 col-sm-12 c11n-space-stack-3x c11n-space--force">
        <!-- Add style="gap: 8px" to override Bootstrap gap-2 -->
        <div class="d-flex flex-column flex-sm-row justify-content-between button_between_gap">

          <!-- Left side: Submit & Cancel buttons -->
          <div class="d-flex flex-column flex-sm-row gap-2 order-2 order-sm-1 button_between_gap">
            <ng-container *appHasPermission="'edit'">
              <c11n-button
                labelText="Update"
                buttonType="submit"
                [isInvalid]="formGroup.invalid"
                [isWaiting]="isWaiting"
                [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
                class="order-2 order-sm-1"
              ></c11n-button>
            </ng-container>
            <c11n-button
              labelText="Close"
              variant="secondary"
              [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
              (clickEvent)="cancelButtonHandler()"
              class="order-1 order-sm-2"
            ></c11n-button>
          </div>

          <!-- Right side: Preview & Clear buttons -->
          <div
            class="button_between_gap d-none d-lg-flex flex-row gap-2 order-1 order-sm-2 align-items-md-center">
            <ng-container *appHasPermission="'delete'">
              <c11n-button class="delete-button-blue"
                labelText="Delete"
                variant="ghost"
                size="small"
                [isInvalid]="formGroup.invalid"
                (clickEvent)="onMessageDelete()"
                [isWaiting]="isDeleteWaiting"
              ></c11n-button>
            </ng-container>
            <c11n-button
              labelText="Print message"
              variant="secondary"
              size="small"
              (clickEvent)="onPrintViewMessageBrowser()"
            ></c11n-button>

            <c11n-button
              labelText="Preview message text"
              variant="secondary"
              size="small"
              (clickEvent)="onPreviewViewMessage()"
            ></c11n-button>
          </div>
        </div>
      </div>
    </div>

  </form>
</ng-container>

<app-confirm-submit #confirmationModal
                    [variant]="'basic'"
                    [headingText]="'Once you click Ok data will be lost.'"
                    (closeEvent)="stayOnPage()"
                    [confirmButtonVariant]="'primary'"
                    [confirmButtonText]="'Ok, go back'"
                    [cancelButtonText]="'No, stay'"
                    (confirmEvent)="leavePage()"
                    (cancelEvent)="stayOnPage()"
></app-confirm-submit>


<app-confirm-submit #submitConfirmationModal
                    [headingText]="'Are you sure you want to update the message?'"
                    [variant]="'basic'"
                    [confirmButtonText]="'Yes, update message'"
                    [cancelButtonText]="'No, go back'"
                    [confirmButtonVariant]="'primary'"
                    (confirmEvent)="confirmSubmit()"
                    (cancelEvent)="cancelSubmit()"
                    (closeEvent)="cancelSubmit()"
></app-confirm-submit>

<app-confirm-submit #deleteConfirmationModal
                    [variant]="'basic'"
                    [headingText]="'Are you ready to delete the message?'"
                    [confirmButtonText]="'Yes, delete message'"
                    [cancelButtonText]="'No, go back'"
                    [confirmButtonVariant]="'primary'"
                    (cancelEvent)="cancelDelete()"
                    (confirmEvent)="confirmDelete()"
                    (closeEvent)="cancelDelete()"
></app-confirm-submit>

<!-- Replace old modal with new component -->
<app-preview-message
  #messagePreviewModal
  [header]="formGroup.get('header')?.value || ''"
  [messageTextLines]="getPreviewMessageLines()"
  [headingText]="'Preview message text'"
  (closeEvent)="onClosePreviewMessage()"
></app-preview-message>
